import { Dialog } from "@material-ui/core";
import { push } from "connected-react-router";
import React from 'react';
import { connect, MapDispatchToPropsFunction, MapStateToProps } from "react-redux";
import StatusView from 'shared/Modules/Error/Components/StatusView';
import { closeConfirmStartingMeetingModal } from "../Actions/confirmStartingMeetingModalActions";
import { closeMeetingOptionsModal } from "../Actions/meetingOptionsModalActions";
import { closeMeetingStartedModal, ICloseMeetingStartedModal } from "shared/Modules/Meeting/meetingModalActions";
import { IStoreState } from '../Reducers/rootReducer';
import ErrorHandlerModal from "shared/Modules/Error/Components/ErrorHandlerModal";
import { Localized } from '@fluent/react';

// These are the props that can/should be passed from a parent component
// It is the only exported prop interface since all other props are internal
export interface IOwnProps {
    // This component does not have own props
}

// These are the props we expect to be passed from Redux state
interface IStateProps {
    isDrawerOpen: boolean
}

// These are the props used to dispatch actions from the component
interface IDispatchProps {
    hideMeetingStartedModal: () => ICloseMeetingStartedModal,
}

type IProps =
    & IOwnProps
    & IStateProps
    & IDispatchProps

const mapStateToProps: MapStateToProps<IStateProps, IOwnProps, IStoreState> = ({ meetingStartedModal, shoppingCart }) => ({
    isDrawerOpen: meetingStartedModal.open,
});
const mapDispatchToProps: MapDispatchToPropsFunction<IDispatchProps, IOwnProps> = (dispatch) => ({
    hideMeetingStartedModal: () => {
        dispatch(closeConfirmStartingMeetingModal());
        dispatch(closeMeetingOptionsModal());
        dispatch(push('/'))
        return dispatch(closeMeetingStartedModal());
    },
});

const ModalContent = (props: IProps) => {
    const { hideMeetingStartedModal } = props;

    return (
        <Localized id="meetingStarted-labels" attrs={{topbarTitle: true, title: true, buttonLabel: true}}>
            <StatusView
                variant="success"
                topbarTitle="Meeting Started"
                title="The meeting has started"
                onClose={hideMeetingStartedModal}
                onButtonClick={hideMeetingStartedModal}
                buttonLabel="Continue"
            />
        </Localized>
    )
}

const Modal = (props: IProps) => {
    const { isDrawerOpen, hideMeetingStartedModal } = props;

    return (
        <div>
            <Dialog fullScreen open={isDrawerOpen}>
                <ErrorHandlerModal close={hideMeetingStartedModal}>
                    <ModalContent {...props} />
                </ErrorHandlerModal>
            </Dialog>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
